let gameID;

export const setGameId = (id) => {
  gameID = id;
};

export const getGameID = () => {
  return gameID;
};
